import Vuex from 'vuex';
import Vue from 'vue';
import system from './modules/system';
import user from './modules/user';
import media from './modules/media';
import playlist from './modules/playlist';

Vue.use(Vuex);

const vuexStore = {
  modules: {
    system,
    user,
    media,
    playlist
  },
  strict: false
};

const store = new Vuex.Store(vuexStore);

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js